/**
 * Chapters access catalog for Pro gating system
 * Defines which chapters are free vs Pro content
 */

import { ChapterCatalog } from '../types/catalog';

export const CHAPTERS: ChapterCatalog = {
  // Free chapters - basic introductory content
  // --- Filozofie ---
  'ceska-filozofie-kapitola': {
    title: 'Česká filozofie',
    access: 'pro'
  },
  'filosoficke-smery': {
    title: 'Základní filosofické směry',
    access: 'free'
  },
  'logika-argumentace': {
    title: 'Logika a argumentace',
    access: 'pro'
  },
  'filosofie-vedy': {
    title: 'Filosofie vědy',
    access: 'free'
  },
  'etika-moralka': {
    title: 'Etika a morálka',
    access: 'pro'
  },
  'epistemo-onto': {
    title: 'Epistemologie a ontologie',
    access: 'pro'
  },
  'religie': {
    title: 'Filozofie religií',
    access: 'pro'
  },

  // --- Psychologie ---
  'chapter-social-psych-01-revised': {
    title: 'Sociální psychologie',
    access: 'pro'
  },
  'chapter-psych-schools-01': {
    title: 'Psychologické směry a přístupy',
    access: 'pro'
  },
  'psychopatologie-a-poruchy-v2-full': {
    title: 'Psychopatologie a poruchy',
    access: 'pro'
  },
  'vyvojove-teorie': {
    title: 'Vývojové teorie',
    access: 'pro'
  },
  'kognitivni-procesy': {
    title: 'Kognitivní procesy',
    access: 'pro'
  },
  'psychoterapeuticke-metody': {
    title: 'Psychoterapeutické metody',
    access: 'pro'
  },
  'uvod-do-psychologie': {
    title: 'Úvod do psychologie',
    access: 'pro'
  },
  'inteligence-a-typologie-osobnosti': {
    title: 'Inteligence a typologie osobnosti',
    access: 'pro'
  },
  'struktury-vedomi-a-nevedomi': {
    title: 'Struktury vědomí a nevědomí',
    access: 'pro'
  },
  'podminovani-a-uceni': {
    title: 'Podmiňování a učení',
    access: 'pro'
  },

  // --- Politologie ---
  'd2b8c3e4-f5a6-4789-b0c1-d2e3f4a5b6c7': {
    title: 'Politický systém České republiky',
    access: 'pro'
  },
  'e3c9d4f5-a6b7-4890-c1d2-e3f4a5b6c7d8': {
    title: 'Mezinárodní organizace',
    access: 'pro'
  },
  'f4d0e5f6-b7c8-4901-d2e3-f4a5b6c7d8e9': {
    title: 'Politické strany a stranické systémy',
    access: 'free'
  },
  'g5e1f6a7-c8d9-5012-e3f4-g5a6b7c8d9f0': {
    title: 'Mezinárodní vztahy a geopolitika',
    access: 'pro'
  },
  'h6f2g7b8-d9e0-6123-f4g5-h6b7c8d9f0g1': {
    title: 'Politické systémy a režimy',
    access: 'pro'
  },
  'i7g3h8c9-e0f1-7234-g5h6-i7c8d9f0g1h2': {
    title: 'Rozdělení moci a ústavní principy',
    access: 'pro'
  },
  'j8h4i9d0-f1g2-8345-h6i7-j8d9f0g1h2i3': {
    title: 'Teorie státu a politické ideologie',
    access: 'pro'
  },
  'k9i5j0e1-g2h3-9456-i7j8-k9e0f1g2h3i4': {
    title: 'Instituce a volební systémy',
    access: 'pro'
  },

  // --- Evropská unie ---
  'evropska-integrace-kapitola': {
    title: 'Historie a vývoj evropské integrace',
    access: 'pro'
  },
  'pravo-eu-kapitola': {
    title: 'Právo EU a současné výzvy',
    access: 'pro'
  },
  'schengen-politiky-eu-kapitola': {
    title: 'Schengen a hlavní politiky EU',
    access: 'pro'
  },
  'euro-integrace-kapitola': {
    title: 'Euro a hospodářská integrace',
    access: 'pro'
  },
  'c1a9b2d3-e4f5-4678-9a0b-1c2d3e4f5a6b': {
    title: 'Instituce a rozhodovací procesy EU',
    access: 'pro'
  },

  // --- Moderní historie ---
  'moderni-dejiny-kapitola': {
    title: 'Moderní dějiny (1848-1918)',
    access: 'pro'
  },
  'moderni-dejiny-2-kapitola-v2-final': {
    title: 'Moderní dějiny (1918-1945)',
    access: 'pro'
  },
  'moderni-dejiny-3-kapitola-v2-final': {
    title: 'Moderní dějiny (po roce 1945)',
    access: 'pro'
  },

  // --- Ekonomie ---
  'zaklady-makro-mikro-ekonomie': {
    title: 'Základy makroekonomie a mikroekonomie',
    access: 'pro'
  },
  'ekonomicke-proudy-historie': {
    title: 'Základní myšlenkové proudy ekonomie napříč historií',
    access: 'pro'
  },
  'hospodarska-politika-cnb': {
    title: 'Hospodářská politika a Česká národní banka',
    access: 'pro'
  },
  'penize-a-bankovnictvi': {
    title: 'Peníze a bankovnictví',
    access: 'pro'
  },

  // --- Sociologie ---
  'soc-vyzkum-metody-pojmy': {
    title: 'Metody a pojmy v sociologickém výzkumu',
    access: 'pro'
  },
  'kultura-a-socializace': {
    title: 'Kultura a socializace',
    access: 'pro'
  },
  'vznik-a-vyvoj-sociologie': {
    title: 'Vznik a vývoj sociologie',
    access: 'free'
  },
  'socialni-struktura-role-deviace': {
    title: 'Sociální struktura, role a deviace',
    access: 'pro'
  },

  // --- Právo ---
  'ustavni-pravo-principy': {
    title: 'Ústavní právo',
    access: 'pro'
  },
  'trestni-pravo-zaklady': {
    title: 'Trestní právo',
    access: 'pro'
  },
  'pracovni-pravo-kapitola-v3-final': {
    title: 'Pracovní právo',
    access: 'pro'
  },
  'obcanske-pravo-kapitola-v2-final': {
    title: 'Občanské právo',
    access: 'pro'
  },
  'pravni-proces-soudnictvi': {
    title: 'Právní proces a soudnictví',
    access: 'pro'
  },
  'legislativni-procesy-regulace': {
    title: 'Legislativní procesy a regulace',
    access: 'pro'
  },

};

/**
 * Get access level for a chapter
 * @param chapterId - The chapter ID to check
 * @returns The access level ('free' or 'pro'), defaults to 'free' if not found
 */
export function getChapterAccess(chapterId: string): 'free' | 'pro' {
  return CHAPTERS[chapterId]?.access || 'free';
}